import React, { memo } from "react";
import WebView from "react-native-webview";
import { Platform } from "react-native";
const KycDigioMandate = ({ digioDocumentId, digioToken, identifier, webUrl, action, triggerAction, options, }) => {
    const onSuccessReceived = async (response) => {
        if (response.type !== undefined || response.error !== undefined || response.is_success !== undefined) {
            action && triggerAction && await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    type: response.type === undefined ? "undefined" : response.type,
                    error: response.error === undefined ? "undefined" : response.error,
                },
            });
        }
    };
    const onNavigationStateChanged = async (webViewState) => {
        var regex = /[?&]([^=#]+)=([^&#]*)/g, params = {}, match;
        while (match = regex.exec(webViewState.url)) {
            params[match[1]] = match[2];
        }
        return onSuccessReceived(params);
    };
    // @ts-ignore
    return (React.createElement(WebView, { style: {
            width: '100%',
            height: 650,
            marginBottom: 20
        }, source: webUrl ? { uri: webUrl } : {
            html: `
          <html>
<body>
<script type="text/javascript" src="https://app.digio.in/sdk/v10/digio.js"></script>
<script type="text/javascript">
         const digioOptions = {
        environment: 'sandbox',

        theme: {
            primaryColor: '#234FDA',
            secondaryColor: '#234FDA',
        },
        logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
        fontFamily: 'Poppins',
        fontUrl:
            'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        is_iframe:  false,
        is_redirection_approach : true,
        //@ts-ignore
        redirect_url: "${options.redirectionUrl}"

    }

var digioObj = new Digio(digioOptions);
       digioObj.init();
            digioObj.submit("${digioDocumentId}","${identifier}")


           const sendDataToReactNativeApp = async (data) => {
                window.ReactNativeWebView.postMessage(data);
              };
      </script>
</body>
</html>
`,
        }, javaScriptEnabled: true, domStorageEnabled: true, onNavigationStateChange: (event) => onNavigationStateChanged(event), originWhitelist: ['*'], automaticallyAdjustContentInsets: false, useWebKit: true, allowsInlineMediaPlayback: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web", scalesPageToFit: false, scrollEnabled: Platform.OS === "ios", injectedJavaScript: `
  $('form:first').css('max-width', '100%');
  $('form:first').css('width', '100%');
  $('div:first').removeClass("wrapper");
  $('form:first').css('position', 'unset');
  $('form:first').css('padding-bottom', '100%');
  $('body').scrollTop({0});` }));
};
export default memo(KycDigioMandate);
export { KycDigioMandate };
